import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import { css } from '@emotion/react';

import { EMPTY_OBJECT } from '@e-socna/empty';

import { useIllustrationUrl } from '../../components/Illustrations/hooks/useIllustrationUrl.hook';
import { TeamIllustration } from '../../components/Illustrations/Team/Team';

import { Avatar } from '../Avatar';

import {
  DEFAULT_ACTOR_PLACEHOLDER_HEIGHT,
  ACTOR_CARD_SIZE,
  ACTOR_CARD_SX,
} from './constants/card.constant';

interface Props {
  readonly isRulesCardVisible: boolean;
  readonly onStartCreate: () => void;
  readonly showRulesCard: () => void;
}

const newActorString = 'Ajouter un nouvel acteur';
const showLabel = 'Afficher les règles';

export const NewActorCard = ({
  isRulesCardVisible,
  onStartCreate: handleStartCreate,
  showRulesCard,
}: Readonly<Props>) => {
  const imageUrl = useIllustrationUrl(TeamIllustration);

  return (
    <Grid size={ACTOR_CARD_SIZE} sx={ACTOR_CARD_SX}>
      <Card sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <CardHeader
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...(!isRulesCardVisible
            ? {
                action: (
                  <Tooltip title={showLabel}>
                    <IconButton aria-label={showLabel} onClick={showRulesCard}>
                      <QuestionMarkIcon />
                    </IconButton>
                  </Tooltip>
                ),
              }
            : EMPTY_OBJECT)}
          avatar={<Avatar icon={<EmojiPeopleIcon />} label={newActorString} />}
          css={css`
            .MuiCardHeader-action {
              display: contents;
            }
          `}
        />
        <CardMedia
          alt={newActorString}
          component="img"
          height={DEFAULT_ACTOR_PLACEHOLDER_HEIGHT}
          image={imageUrl}
        />
        <CardContent sx={{ flexGrow: 1 }}>
          <Typography color="text.secondary" variant="body2">
            {newActorString}
          </Typography>
        </CardContent>
        <CardActions>
          <Button onClick={handleStartCreate} size="medium" variant="outlined">
            Formulaire
          </Button>
        </CardActions>
      </Card>
    </Grid>
  );
};
